import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Loader from "@/components/Loader";

export default function Infos() {
  const [venue, setVenue] = useState(null);
  const [infos, setInfos] = useState(null);

  useEffect(() => {
    api.get("/config/venue").then(({ data }) => setVenue(data));
    api.get("/config/infos").then(({ data }) => setInfos(data));
  }, []);

  if (!venue || !infos) return <Loader />;

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-black gradient-text inline-block">{infos.title}</h1>
      <p className="text-neutral-400 mt-2">{infos.subtitle}</p>

      <div className="grid md:grid-cols-2 gap-4 mt-8">
        <div className="card-hsg p-6">
          <div className="chip" style={{ background: "#5BC5F222", color: "#5BC5F2", border: "1px solid #5BC5F255" }}>📍 Lieu</div>
          <h3 className="font-bold text-lg mt-3">{venue.name}</h3>
          <p className="text-neutral-300 text-sm mt-1">{venue.address}</p>
          {venue.mapsQuery && (
            <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(venue.mapsQuery)}`} target="_blank" rel="noreferrer" className="text-[#5BC5F2] text-sm mt-3 inline-block">
              Ouvrir dans Google Maps →
            </a>
          )}
        </div>
        <div className="card-hsg p-6">
          <div className="chip" style={{ background: "#A1C86122", color: "#A1C861", border: "1px solid #A1C86155" }}>🚗 Accès</div>
          <ul className="mt-4 space-y-2 text-sm text-neutral-300">
            {venue.transport_car && <li>🚗 {venue.transport_car}</li>}
            {venue.transport_train && <li>🚆 {venue.transport_train}</li>}
            {venue.transport_bike && <li>🚲 {venue.transport_bike}</li>}
          </ul>
        </div>
      </div>

      <div className="card-hsg p-6 mt-4">
        <div className="chip" style={{ background: "#FEC90022", color: "#FEC900", border: "1px solid #FEC90055" }}>ℹ️ Bon à savoir</div>
        <ul className="mt-4 space-y-2 text-neutral-300 text-sm">
          <li>• Ouverture des portes : 10h30 chaque jour</li>
          <li>• Enfants de 0 à 2 ans : entrée gratuite</li>
          <li>• Paiements aux stands : uniquement via le bracelet cashless</li>
          <li>• Objets perdus / trouvés : accueil principal</li>
          <li>• Contact : festival@herisson-sous-gazon.ch</li>
        </ul>
      </div>
    </div>
  );
}
